import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const PermissionRoute = ({ children, permission }) => {
  const permissions = useSelector((state) => state.auth.permissions || []);

  return permissions.includes(permission) ? (
    children
  ) : (
    <Navigate to="/unauthorized" replace />
  );
};

export default PermissionRoute;
